import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', loadChildren: () => import('./modules/site/site.module').then(m => m.SiteModule) },
    { path: 'users', loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule) },
    { path: 'accounts', loadChildren: () => import('./modules/accounts/accounts.module').then(m => m.AccountsModule) },
    { path: 'agreements', loadChildren: () => import('./modules/agreements/agreements.module').then(m => m.AgreementsModule) },
  ];